/**
 * Created by daniesy on 09/11/2016.
 */
// var d3 = require('d3');
import csv from './tools/csv';

export default class Data {
    constructor(csvPath, onFinished, autoload = true) {
        this.csvPath = csvPath;
        this.onFinished = onFinished;
        if (autoload) this.load();
    }

    load() {
        csv(this.csvPath, (error, data) => this.onFinished(data));
        // dsv.dsvFormat(";")(this.csvPath, (error, data) => this.onFinished(data));
    }
}



// WEBPACK FOOTER //
// ./src/js/data.js